// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.Sample = M.View.Sample || {};

/**
 * @class M.View.Sample.SampleDialog
 *
 */
M.View.Sample.SampleDialog = Backbone.View.extend({
  className: 'addSampleDialog',
  events: {
    'click .cancelButton': 'cancel',
    'click .btnNext': 'next',
    'click .paperOption': 'setSelectedPaper',
    'click .colorOption': 'setSelectedColor'
  },

  POST_URL: '/sample/add',

  initialize: function() {
    _.bindAll(this, 'addToCart');

    this.$el = $(this.el);

    var templateHtml = M.Template.Sample.SampleDialog;

    this.template = _.template(templateHtml);
    this.customColorsModel = null;

    if (this.options.launchedFromPDP) {
      this.origin = 'PDP';
    } else if (this.options.launchedFromQuickLook) {
      this.origin = 'quicklook';
    } else {
      this.origin = 'category_page';
    }
  },

  render: function() {
    var html = this.template(this.model.toJSON());
    this.$el.html(html);

    if (this.model.get('paperChoices').length > 1) {
      this.truncatePaperDescriptions();
    }

    this.renderDatePicker();

    return this.$el;
  },

  renderDatePicker: function() {
    this.dateModel = new M.Model.DatePicker({
      showYear: true,
      reverseYearOrder: false,
      minYear: new Date().getFullYear(),
      maxYear: new Date().getFullYear() + 10
    });

    var dateView = new M.View.DatePicker({
      model: this.dateModel,
      tagName: 'div'
    });
    this.$el.find('.dialogDatePickerTarget').append(dateView.render().el);
  },

  truncatePaperDescriptions: function() {
    // Truncate paper descriptions and add the 'more' text.
    this.$el.find('.paperDesc').jTruncate({
      length: 30,
      minTrail: 0
    });
  },

  cancel: function() {
    var trackData = {
      feature: M.GA.TRACK_EVENT_CATEGORY.SAMPLE_MODAL,
      event: M.GA.TRACK_EVENT_ACTION.SAMPLE_DESIGN_MODAL_CANCEL_CLICK,
      sku: this.model.get('sku'),
      origin: this.origin
    };
    M.sendTrackAPI(trackData);

    this.trigger('closeDialog');
    this.$el.remove();

    if (this.options.launchedFromQuickLook) {
      $(".quickLookDialog").find(".productPreview").css("display", "block");
    } else {
      $(".quickLookDialog").remove();
    }
  },

  addSpinner: function() {
    var $el = this.$el.find('.btnNext');
    $el.addClass('button--spinner');
    $el.attr('disabled','disabled');
  },

  removeSpinner: function() {
    var $el = this.$el.find('.btnNext');
    $el.removeClass('button--spinner');
    $el.removeAttr('disabled');
  },

  next: function(e) {
    this.addSpinner();

    var sku = this.model.get('sku');
    var trackData = {
      feature: M.GA.TRACK_EVENT_CATEGORY.SAMPLE_MODAL,
      event: M.GA.TRACK_EVENT_ACTION.SAMPLE_DESIGN_MODAL_NEXT_CLICK,
      sku: sku,
      origin: this.origin
    };
    M.sendTrackAPI(trackData);

    if (this.$el.find('input[name="colorChoice"]:checked').val() === 'custom') {
      // only create a new model if one doesn't exist
      // this will maintain user input if dialogs are closed
      if (this.customColorsModel === null) {
        this.customColorsModel = new M.Model.Sample.CustomColors({
          sku: sku,
          selectedColors: new M.Collection.Sample.ColorChoiceList(),
          userColors: new M.Collection.Sample.ColorChoiceList()
        });
      }
      var customColorsView = new M.View.Sample.CustomColors({
        model: this.customColorsModel
      });
      // show custom color view
      customColorsView.render();
      customColorsView.bind('done', this.addToCart);
    } else {
      // add to cart
      this.addToCart();
    }
  },

  setSelectedColor: function(e) {
    this.model.set({'selectedColor': $(e.target).val()});
  },

  setSelectedPaper: function(e) {
    var selectedPaperId = $(e.target).val();
    var selectedPaper = _(this.model.get('paperChoices')).find(function(paperChoice) {
      return paperChoice.id == selectedPaperId;
    });

    this.model.set({
      'selectedPaper': selectedPaper,
      'selectedPaperId': selectedPaperId
    });
  },

  // TODO: Remove this. Simply pass the model to the addToCart request.
  // See "selectedPaper" and "selectedColor". Don't grab from the DOM.
  _formatPostData: function(customColors) {
    var postData = {
      sku: this.model.get('sku'),
      paper: this.model.get('selectedPaper').id,
      color: this.$el.find('input[name="colorChoice"]:checked').val(),
      defaultColor: this.$el.find('input[name="colorChoice"]').val(),
      weddingDay: this.dateModel.getSelectedDate().getDate(),
      weddingMonth: this.dateModel.getSelectedDate().getMonth()+1,
      weddingYear: this.dateModel.getSelectedDate().getFullYear(),
      weddingSuite: this.$el.find('input[name="weddingSuiteOption"]:checked').val() == "on",
      sampleUsesGenericBacker: this.model.get('sampleUsesGenericBacker')
    };

    if (customColors) {
      postData['selectedColors'] =
        JSON.stringify(customColors.get('selectedColors').models);
      postData['userColors'] =
        JSON.stringify(customColors.get('userColors').models);
      postData['instructions'] = customColors.get('instructions');
    }
    return postData;
  },

  // TODO: Remove gaTrackEventWrapper() from the global namespace.
  _trackGAEvent: function() {
    gaTrackEventWrapper(this.model.get('source'), 'Added Sample To Cart');
  },

  success: function(that) {
    that.removeSpinner();

    var isCustomizable =
      !that.model.get('isLetterpress') && !that.model.get('isFoilPress');

    that.confirmDialog = new M.View.Sample.ConfirmDialog({
      isCustomizable: isCustomizable
    });

    that.confirmDialog.render();
    that.confirmDialog.bind('close', function() {
      that.trigger('closeDialog');
    });
    that._trackGAEvent();
  },

  error: function(that) {
    that.removeSpinner();

    var errorDialogData = new M.Model.InfoDialog({
      title: 'Error',
      body: 'There was an error adding a sample to your cart. Please try again.'
    });
    that.errorDialog = new M.View.InfoDialog({
      model: errorDialogData
    });
    that.errorDialog.render();
  },

  addToCart: function(customColors) {
    var postData = this._formatPostData(customColors);
    this._post(this.POST_URL, postData, this.success, this.error);
  },

  /**
   * Post 'add sample' request to the server.
   *
   * @param {String} url
   * @param {Dict} postData
   * @param {Function} success
   * @param {Function} error
   * @return {XHR}
   */
  _post: function(url, postData, success, error) {
    var successHandler = success || function() {};
    var errorHandler = error || function() {};
    var that = this;
    var xhr = $.ajax({
      data: postData,
      type: 'POST',
      url: url,
      success: function() {
        successHandler(that);
      },
      error: function() {
        errorHandler(that);
      }
    });
    return xhr;
  }

});
